<template>
  <v-container fluid>
    <BreadHeader
      :title="`Detach ${intermediateModel.name.singular} from ${parentModel.name.singular}`"
    ></BreadHeader>
    <AError :api="api" />
    <v-card>
      <v-card-text>
        <span
          >Are you sure you want to detach
          {{ intermediateModel.name.singular }}
          <b class="black--text">{{ childModelName }}</b> from
          {{ parentModel.name.singular }}
          <b class="black--text">{{ parentModelName }}</b
          >?</span
        >
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$router.go(-1)"> Cancel </v-btn>
        <v-btn :isLoading="api.isLoading" color="error" @click="api.fetch()">
          Detach
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import Api from "@/objects/api";
import BreadcrumbTabulator from "@/objects/breadcrumbTabulator";
import Model from "@/objects/model";
import Service from "@/objects/service";
import { mapState } from "vuex";

export default {
  computed: {
    childModelName() {
      if (this.childModelData) {
        if (this.childModel.column && this.childModel.column.name)
          return this.childModelData[this.childModel.column.name];
        if (this.childModelData.name) return this.childModelData.name;
      }
      return this.childModelId;
    },
    parentModelName() {
      if (this.parentModelData) {
        if (this.parentModel.column && this.parentModel.column.name)
          return this.parentModelData[this.parentModel.column.name];
        if (this.parentModelData.name) return this.parentModelData.name;
      }
      return this.parentModelId;
    },
    ...mapState({
      services: (state) => state.service.data.services,
    }),
  },
  data: () => ({
    api: new Api(),
    apiReadIntermediate: new Api(),
    breadcrumbTabulator: new BreadcrumbTabulator(),
    childModel: new Model(),
    childModelData: null,
    parentModel: new Model(),
    parentModelId: null,
    parentModelData: null,
    intermediateModel: new Model(),
    intermediateModelId: null,
    service: new Service(),
  }),
  created() {
    this.parentModel.getByKey(this.$route.params.parentModelKey);
    this.parentModelId = this.$route.params.parentModelId;
    this.childModel.getByKey(this.$route.params.childModelKey);
    this.intermediateModel.getByKey(this.$route.params.intermediateModelKey);
    this.intermediateModelId = this.$route.params.intermediateModelId;
    if (this.parentModel.serviceKey)
      this.service.set("key", this.parentModel.serviceKey);
    this.breadcrumbTabulator.addForOperationChildDetach({
      services: this.services,
      parentModel: this.parentModel,
      parentModelId: this.parentModelId,
      childModel: this.childModel,
      intermediateModel: this.intermediateModel,
      intermediateModelId: this.intermediateModelId,
    });

    this.apiReadIntermediate.setUrl(
      `${this.$service[this.service.key]}/v1/en/console/tabulator/model/${
        this.intermediateModel.key
      }/${this.intermediateModelId}`,
    );
    this.apiReadIntermediate.setCallbackCompleted((resp) => {
      this.parentModelData =
        resp[this.$_ucfirst(this.$route.params.parentModelKey)];
      this.childModelData =
        resp[this.$_ucfirst(this.$route.params.childModelKey)];
    });
    this.apiReadIntermediate.fetch();

    this.api.setMethod(`POST`);
    this.api.setUrl(
      `${
        this.$service[this.intermediateModel.serviceKey]
      }/v1/en/console/tabulator/model/${this.childModel.key}/${
        this.intermediateModelId
      }/delete/hard`,
    );
    this.api.setParams({
      byForce: true,
    });
    this.api.setCallbackCompleted(() => {
      this.$router.push({
        name: "PageServiceModelBreadTabulatorRead",
        query: {
          tab: this.intermediateModel.key,
        },
        params: {
          serviceKey: this.parentModel.serviceKey,
          modelKey: this.parentModel.key,
          modelId: this.parentModelId,
        },
      });
      this.$store.dispatch("showMessage", {
        message: "Detached successfully.",
        messageType: "success",
        timeout: 2000,
      });
    });
  },
};
</script>
